import { AnswerType, ICategory } from "../models";

export const roundMovies: ICategory[] = [
	{
		id: "1qxjjd4k1scs3a1",
		name: "Star Wars and Marvel",
		answers: [
			{
				id: "1qxjjd4k1scs3a6",
				type: AnswerType.TEXT,
				answer: "This is the name of the new Avengers movie",
				answerDe: "So heißt der neue Avengers-Film?",
				question: "Avengers: Endgame",
				explanation: "",
				points: 200,
				show: false,
				answered: false
			},
			{
				id: "1qxjjd4k1scs3ag",
				type: AnswerType.TEXT,
				answer: "This is the name of Han Solo's ship",
				answerDe: "So heißt das Schiff von Han Solo",
				question: "Millennium Falcon",
				explanation: "",
				points: 400,
				show: false,
				answered: false
			},
			{
				id: "1qxjjd4k1scs3al",
				type: AnswerType.TEXT,
				answer: "This young Jedi Knight becomes Darth Vader in Star Wars",
				answerDe: "Dieser junge Jedi-Ritter wird Darth Vader in Star Wars",
				question: "Anakin Skywalker",
				explanation: "",
				points: 600,
				show: false,
				answered: false
			},
			{
				id: "1qxjjd4k1scs3ab",
				type: AnswerType.TEXT,
				answer: "This is the name of Star-Lord's ship in Guardians of the Galaxy",
				answerDe: "So heißt das Schiff von Star-Lord in Guardians of the Galaxy",
				question: "Milano",
				explanation: "",
				points: 800,
				show: false,
				answered: false
			},
			{
				id: "1qxjjd4k1scs3aq",
				type: AnswerType.TEXT,
				answer: "Here Iron Man fought Whiplash for the first time",
				answerDe: "Hier hat Iron Man zum ersten Mal gegen Whiplash gekämpft",
				question: "Monaco",
				explanation: "",
				points: 1000,
				show: false,
				answered: false
			}
		]
	},
	{
		id: "1qxjjd4k1scs3a2",
		name: "Pixar Movies",
		answers: [
			{
				id: "1qxjjd4k1scs3a7",
				type: AnswerType.TEXT,
				answer: "This animated feature film was Pixar's first release in 1995",
				answerDe: "Dieser Animationsfilm war die erste Veröffentlichung von Pixar im Jahr 1995",
				question: "Toy Story",
				explanation: "",
				points: 200,
				show: false,
				answered: false
			},
			{
				id: "1qxjjd4k1scs3ac",
				type: AnswerType.TEXT,
				answer: 'The movie "WALL-E" features a robot of the same name. This is his job.',
				answerDe: 'Der Film "WALL-E" zeigt einen gleichnamigen Roboter. Das ist sein Job.',
				question: "Trash Collector",
				explanation: "",
				points: 400,
				show: false,
				answered: false
			},
			{
				id: "1qxjjd4k1scs3am",
				type: AnswerType.TEXT,
				answer: 'This European city is the setting for the 2007 movie "Ratatouille"',
				answerDe: 'In dieser europäischen Stadt spielt der Film "Ratatouille" von 2007',
				question: "Paris",
				explanation: "",
				points: 600,
				show: false,
				answered: false
			},
			{
				id: "1qxjjd4k1scs3ah",
				type: AnswerType.TEXT,
				answer:
					'This Pixar character says, "No matter how many times you save the world, it always manages to get back in jeopardy again?"',
				answerDe:
					'Dieser Pixar-Charakter sagt: "Ganz egal wie oft man die Welt rettet, sie schafft es immer wieder sich in Gefahr zu bringen?"',
				question: "Mr. Incredible",
				explanation: "",
				points: 800,
				show: false,
				answered: false
			},
			{
				id: "1qxjjd4k1scs3ar",
				type: AnswerType.TEXT,
				answer:
					'This is where the character Carl Fredricksen moves in in the Oscar-winning film "Up"',
				answerDe:
					'Hierhin zieht der Charakter Carl Fredricksen in dem Oscar-prämierten Film "Oben"',
				question: "Paradise Falls / Paradiesfälle",
				explanation: "",
				points: 1000,
				show: false,
				answered: false
			}
		]
	},
	{
		id: "1qxjjd4k1scs3a3",
		name: "Princesses",
		answers: [
			{
				id: "1qxjjd4k1scs3an",
				type: AnswerType.TEXT,
				answer: "Name the 2 Disney Princesses who have red hair.",
				answerDe: "Die 2 Disney-Prinzessinnen, die rotes Haar haben.",
				question: "Princess Merida, Ariel (The Little Mermaid)",
				explanation: "",
				points: 200,
				show: false,
				answered: false
			},
			{
				id: "1qxjjd4k1scs3a8",
				type: AnswerType.TEXT,
				answer: "Name the only Disney Princess based on a real life person. ",
				answerDe: "Die einzige Disney-Prinzessin, die auf einer echten Person basiert.",
				question: "Pocahontas ",
				explanation: "",
				points: 400,
				show: false,
				answered: false
			},
			{
				id: "1qxjjd4k1scs3ai",
				type: AnswerType.TEXT,
				answer: "Who are three princesses who had evil stepmothers?",
				answerDe: "Nenne drei Prinzessinnen, die böse Stiefmütter hatten",
				question: "Snow White, Cinderella, Rapunzel ",
				explanation: "",
				points: 600,
				show: false,
				answered: false
			},
			{
				id: "1qxjjd4k1scs3as",
				type: AnswerType.TEXT,
				answer: "This Disney princess movie was the first to show war",
				answerDe: "Dieser Disney-Prinzessinnenfilm war der erste, der den Krieg zeigte.",
				question: "Mulan",
				explanation: "",
				points: 800,
				show: false,
				answered: false
			},
			{
				id: "1qxjjd4k1scs3ad",
				type: AnswerType.TEXT,
				answer: "Name the only Disney Princess with hazel eyes. ",
				answerDe: "Die einzige Disney-Prinzessin mit braunen Augen.",
				question: "Belle ",
				explanation: "",
				points: 1000,
				show: false,
				answered: false
			}
		]
	},
	{
		id: "1qxjj0ek1sccaie",
		name: "Cartons",
		answers: [
			{
				id: "1qxjj0ek1sccaij",
				type: AnswerType.TEXT,
				answer: "A cartoon about a sponge in the ocean.",
				answerDe: "Ein Cartoon über einen Schwamm im Meer.",
				question: "What is SpongeBob SquarePants?",
				explanation: "",
				points: 200,
				show: false,
				answered: false
			},
			{
				id: "1qxjj0ek1sccait",
				type: AnswerType.TEXT,
				answer: "A show about ponies and friendship. ",
				answerDe: "Eine Show über Ponys und Freundschaft.",
				question: "What is My Little Pony Friendship is Magic?",
				explanation: "",
				points: 400,
				show: false,
				answered: false
			},
			{
				id: "1qxjj0ek1sccaiy",
				type: AnswerType.TEXT,
				answer: "A show about 3 super powered girls fighting crime.",
				answerDe: "Eine Show über 3 superstarke Mädchen, die Verbrechen bekämpfen.",
				question: "What is The Power Puff Girls?",
				explanation: "",
				points: 600,
				show: false,
				answered: false
			},
			{
				id: "1qxjj0ek1sccaio",
				type: AnswerType.TEXT,
				answer: "A show about a little boy who has fairy godparents.",
				answerDe: "Eine Show über einen kleinen Jungen, der Elfen als Eltern hat.",
				question: "What is The Fairly Odd Parents? / Cosmo und Wanda",
				explanation: "",
				points: 800,
				show: false,
				answered: false
			},
			{
				id: "1qxjj0ek1sccaj3",
				type: AnswerType.TEXT,
				answer: "An older show about a Samurai fighting to save the world from robots.",
				answerDe:
					"Eine ältere Show über einen Samurai, der darum kämpft, die Welt vor Robotern zu retten.",
				question: "What is Samurai Jack?",
				explanation: "",
				points: 1000,
				show: false,
				answered: false
			}
		]
	},
	{
		id: "1qxjiv9k1sca3q8",
		name: "Lord of the Rings",
		answers: [
			{
				id: "1qxjiv9k1sca3qd",
				type: AnswerType.TEXT,
				answer:
					"This character started the series under a different color designation, but finishes the series as “the White.” ",
				answerDe:
					'Dieser Charakter begann die Serie unter einer anderen Farbbezeichnung, beendet die Serie aber als "der Weiße".',
				question: "Who is Gandalf?",
				explanation: "",
				points: 200,
				show: false,
				answered: false
			},
			{
				id: "1qxjiv9k1sca3qi",
				type: AnswerType.TEXT,
				answer:
					"This director brought the Lord of the Rings trilogy into the new millennium with an award-winning series of films based on these novels. ",
				answerDe:
					'Dieser Regisseur brachte die Trilogie "Herr der Ringe" mit einer preisgekrönten Filmreihe, die auf diesen Romanen basiert, ins neue Jahrtausend."',
				question: "Who is Peter Jackson?",
				explanation: "",
				points: 400,
				show: false,
				answered: false
			},
			{
				id: "1qxjiv9k1sca3qn",
				type: AnswerType.TEXT,
				answer:
					"This prequel to the Lord of the Rings trilogy includes the story of the creation of Ea, the fictional setting for these books. ",
				answerDe:
					"Diese Vorgeschichte zur Trilogie Herr der Ringe beinhaltet die Geschichte der Entstehung von Ea, dem fiktiven Schauplatz dieser Bücher.",
				question: "What is The Silmarillion?",
				explanation: "",
				points: 600,
				show: false,
				answered: false
			},
			{
				id: "1qxjiv9k1sca3qs",
				type: AnswerType.TEXT,
				answer:
					"This ring of power was wielded by Galadriel, and lent it’s preservative powers to her domain, Lorien. ",
				answerDe:
					"Dieser Ring der Macht wurde von Galadriel getragen und verlieh seine Kräfte ihrem Reich Lorien.",
				question: "What is Nenya?",
				explanation: "",
				points: 800,
				show: false,
				answered: false
			},
			{
				id: "1qxjiv9k1sca3qx",
				type: AnswerType.TEXT,
				answer:
					"With it’s counterpart Quenya, Tolkien invented this language, spoken by the “Gray Elves” of Middle-Earth. ",
				answerDe:
					"Mit seinem Gegenstück Quenya erfand Tolkien diese Sprache, die von den Grauelben Mittelerdes gesprochen wird.",
				question: "What is Sindarin?",
				explanation: "",
				points: 1000,
				show: false,
				answered: false
			}
		]
	}
];
